export class GooglePayPaymentDataError extends Error {
  constructor(request: google.payments.api.PaymentDataRequest) {
    super(`Failed to load payment date for request ${JSON.stringify(request)}`);
    this.name = 'GooglePayPaymentDataError';
  }
}
